import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import App from "./App";
import SingleVideo from "./SingleVideo";
import Playlist from "./Playlist";
import ViewPlaylists from "./ViewPlaylists";
import ContactUs from "./ContactUs";
import EmbedVideo from "./EmbedVideo";
import PartyPassSuccess from "./pages/PartyPassSuccess";
import Signup from "./pages/Signup";
import TermsOfService from "./TermsOfService";
import PrivacyPolicy from "./PrivacyPolicy";
import MusicVideoFeed from "./MusicVideoFeed";
import Library from "./Library";
import utc from "dayjs/plugin/utc";
import dayjs from "dayjs";
import "./index.scss";
import AuthProvider from "./components/AuthProvider";

dayjs.extend(utc);

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

ReactDOM.render(
  <GoogleOAuthProvider clientId={googleClientId}>
    <Router>
      <AuthProvider>
        <Routes>
          <Route exact path="/signup" element={<Signup />} />
          <Route exact path="/" element={<App />} />
          <Route exact path="/home" element={<App />} />
          <Route exact path="/video/*" element={<SingleVideo />} />
          <Route exact path="/allplaylists" element={<ViewPlaylists />} />
          <Route exact path="/playlist/*" element={<Playlist />} />
          <Route exact path="/contactus" element={<ContactUs />} />
          <Route exact path="/embed/:videoId" element={<EmbedVideo />} />
          <Route exact path="/party-pass/success" element={<PartyPassSuccess />} />
          <Route exact path="/terms" element={<TermsOfService />} />
          <Route exact path="/privacy" element={<PrivacyPolicy />} />
          <Route exact path="/discover" element={<MusicVideoFeed />} />
          <Route exact path="/library" element={<Library />} />
        </Routes>
      </AuthProvider>
    </Router>
  </GoogleOAuthProvider>,
  document.getElementById("root")
);
